import React from 'react'

type TopbarBalanceProps = {
  balance: number
}

const TopbarBalance: React.FunctionComponent<TopbarBalanceProps> = ({
  balance,
}) => (
  <div className="topbar__balance">
    <p className="topbar__balance-text">Balance</p>
    <p className="topbar__balance-text">${balance}</p>
  </div>
)
export default TopbarBalance
